define('OutSystems/ClientRuntime/Injector/KnownServices',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ServiceNames = void 0;
    var ServiceNames;
    (function (ServiceNames) {
        ServiceNames["DeviceHelperClassProvider"] = "DeviceHelperClassProvider";
        ServiceNames["ClientVariablesService"] = "ClientVariablesService";
        ServiceNames["TranslationsService"] = "TranslationsService";
        ServiceNames["LocaleService"] = "LocaleService";
        ServiceNames["EntityService"] = "EntityService";
        ServiceNames["GlobalExceptionHandler"] = "GlobalExceptionHandler";
    })(ServiceNames || (exports.ServiceNames = ServiceNames = {}));
});
//# sourceMappingURL=KnownServices.js.map;
